import { render } from "./login-signup.vue?vue&type=template&id=3c54ebda&scoped=true"
import script from "./login-signup.vue?vue&type=script&lang=js"
export * from "./login-signup.vue?vue&type=script&lang=js"

import "./login-signup.vue?vue&type=style&index=0&id=3c54ebda&scoped=true&lang=css"

import exportComponent from "/appwd/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c54ebda"]])

export default __exports__